/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_SubscribedInputs */

const en_dialog_subscribed = /** @type {(inputs: Dialog_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscribed`)
};

const es_dialog_subscribed = /** @type {(inputs: Dialog_SubscribedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suscrito`)
};

/**
* | output |
* | --- |
* | "Subscribed" |
*
* @param {Dialog_SubscribedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_subscribed = /** @type {((inputs?: Dialog_SubscribedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_SubscribedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_subscribed(inputs)
	return en_dialog_subscribed(inputs)
});